import _getIterator from "@babel/runtime-corejs2/core-js/get-iterator";
import _Array$isArray from "@babel/runtime-corejs2/core-js/array/is-array";
import _Symbol$iterator from "@babel/runtime-corejs2/core-js/symbol/iterator";
import _Symbol from "@babel/runtime-corejs2/core-js/symbol";
import _Array$from from "@babel/runtime-corejs2/core-js/array/from";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.string.ends-with";
import _parseInt from "@babel/runtime-corejs2/core-js/parse-int";
import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.split";

function _createForOfIteratorHelper(o) { if (typeof _Symbol === "undefined" || o[_Symbol$iterator] == null) { if (_Array$isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = _getIterator(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return _Array$from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import Cookies from 'js-cookie';
import { getDisplayName } from './cms/divisionCodeDisplayNameMap';
export function parseQuery(queryString) {
  var query = {};
  var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');

  var _iterator = _createForOfIteratorHelper(pairs),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var pairString = _step.value;
      var pair = pairString.split('=');
      query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return query;
}
export function _isInteger(value) {
  return value != null && value.match(/^\d+$/) != null;
}
export function _isGuid(value) {
  return value != null && value.match(/^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/) != null;
}
export function normalizeAllowedQueryNumbers(query, allowedQueryKeys) {
  return allowedQueryKeys.reduce(function (obj, key) {
    var val = query[key];

    if (_isInteger(val)) {
      var num = _parseInt(val, 10);

      var storageKey;

      if (key === 'caid') {
        // maps query string caid to contractAccountId
        storageKey = 'contractAccountId';
      } else {
        storageKey = key;
      }

      obj[storageKey] = "".concat(num);
    }

    return obj;
  }, {});
}
export var isNative = function isNative() {
  return windowExists && window.navigator.userAgent.endsWith('odin-mobile-app');
};
export var getCookieValue = function getCookieValue(cookieName) {
  return Cookies.get(cookieName);
};
export var setCookieValue = function setCookieValue(cookieName, cookieValue, cookieAttrs) {
  Cookies.set(cookieName, cookieValue, cookieAttrs);
};
export var windowExists = typeof window !== 'undefined';
export var getContractFiltered = function getContractFiltered(property) {
  return property.contractAccounts.map(function (account) {
    return {
      contractAccountId: account.contractAccountId,
      divisionCode: account.divisionCode,
      divisionDisplayName: getDisplayName(account.divisionCode),
      premiseId: property.premiseId,
      status: account.status
    };
  });
};